export const REFERRAL_INFO = 'CONNECT_DOMAIN_ON_4TH_PUBLISH';
export const CONNECT_DOMAIN_4TH_PUBLISH = 'CONNECT_DOMAIN_4th_publish';
export const CONNECT_DOMAIN_ON_4TH_PUBLISH_NEW_DOMAIN =
  'CONNECT_DOMAIN_ON_4TH_PUBLISH_NEW_DOMAIN';
export const CONNECT_DOMAIN_ON_4TH_PUBLISH_EXISTING_DOMAIN =
  'CONNECT_DOMAIN_ON_4TH_PUBLISH_EXISTING_DOMAIN';
